import { useEffect, useRef, useState } from 'react';
import PageIntro from '../../components/PageIntro/PageIntro';
import TalentTable from '../../components/Table/TalentTable';
import RegisterTalentModal from '../../components/Talent/RegisterTalentModal';
import BulkRegisterTalentsModal from '../../components/Talent/BulkRegisterTalentsModal';

const Talents = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [singleOpen, setSingleOpen] = useState(false);
  const [bulkOpen, setBulkOpen] = useState(false);
  /* The list is fetched by SWR inside TalentTable. Remounting it is the
     smallest way to show a talent who was just registered, without lifting
     the hook out of the table or handing it a refresh prop. */
  const [reloadKey, setReloadKey] = useState(0);
  const menuRef = useRef(null);

  /* Same as the Role Library menu: a menu that only closes when its own
     button is clicked again stays hanging over the page when you click
     elsewhere or open a modal from it. */
  useEffect(() => {
    if (!menuOpen) return undefined;
    const onPointerDown = (e) => {
      if (!menuRef.current?.contains(e.target)) setMenuOpen(false);
    };
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };
    document.addEventListener('pointerdown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('pointerdown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [menuOpen]);

  const refresh = () => setReloadKey((k) => k + 1);

  return (
    <div className='mx-auto max-w-7xl space-y-6'>
      <PageIntro
        title={'All Talents'}
        actions={
          <div className='relative' ref={menuRef}>
            <button
              type='button'
              aria-haspopup='menu'
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((o) => !o)}
              className='inline-flex h-10 items-center rounded-lg bg-brand-orange px-4 text-sm font-semibold text-white transition-colors hover:bg-brand-orange-600'
            >
              Register user
              <span className='ml-2 text-xs'>▼</span>
            </button>
            {menuOpen ? (
              <div
                role='menu'
                className='absolute right-0 z-20 mt-1 w-56 rounded-md border border-border bg-card p-1 shadow-lg'
              >
                <button
                  type='button'
                  role='menuitem'
                  onClick={() => {
                    setMenuOpen(false);
                    setSingleOpen(true);
                  }}
                  className='block w-full rounded px-3 py-2 text-left text-sm hover:bg-accent'
                >
                  Single registration
                </button>
                <button
                  type='button'
                  role='menuitem'
                  onClick={() => {
                    setMenuOpen(false);
                    setBulkOpen(true);
                  }}
                  className='block w-full rounded px-3 py-2 text-left text-sm hover:bg-accent'
                >
                  Bulk upload
                </button>
              </div>
            ) : null}
          </div>
        }
      />

      <TalentTable key={reloadKey} />

      <RegisterTalentModal
        open={singleOpen}
        onClose={() => setSingleOpen(false)}
        onRegistered={refresh}
      />
      <BulkRegisterTalentsModal
        open={bulkOpen}
        onClose={() => setBulkOpen(false)}
        onFinished={refresh}
      />
    </div>
  );
};

export default Talents;
